import { useEffect, useState } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, DateInput, NumberInput, TimeInput } from "../../components/forms/Inputs"
import { toCurrency } from "../../hooks/helpers"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"
import { useApi } from "../../hooks/useApi"
import { useParams } from "react-router-dom"
import { ChantierFields } from "./Chantiers"
import { useObjectState } from "../../hooks/useObjectState"
import { Button } from "../../components/layout/Button"
import { FaBan, FaSave } from "react-icons/fa"
import { Form } from "../../components/forms/Form"
import { useToday } from "../../hooks/useToday"
import { useSociete } from "../../hooks/useSociete"

function TempsFields({ item, set, originalItem, personnel }) {
    const [chantier, setChantier] = useState()
    const societe = useSociete()
    const t = useTranslations()
    const personnelOptions = useOptions('personnel', ['prenom', 'nom', 'fournisseur'], { label: x => `${x.prenom || ''} ${x.nom || ''}${x.fournisseur ? ` (${x.fournisseur.nom})` : ''}`, query: 'fournisseur:join=nom' })
    const chantierOptions = useOptions('chantiers', 'nom')
    const fournisseurOptions = useOptions('fournisseurs', 'nom')
    const poubOptions = useOptions('codesSortiePoubelles', 'code', { query: '', link: false })
    const api = useApi()
    const { id, relatedId } = useParams()

    const totalTimeHebdomadaire = (item.tempsLundi || 0) + (item.tempsMardi || 0) + (item.tempsMercredi || 0) + (item.tempsJeudi || 0) + (item.tempsVendredi || 0) + (item.tempsSamedi || 0) + (item.tempsDimanche || 0)
    const totalTimeFrequentiel = (item.tempsJanvier || 0) + (item.tempsFevrier || 0) + (item.tempsMars || 0) + (item.tempsAvril || 0) + (item.tempsMai || 0) + (item.tempsJuin || 0) + (item.tempsJuillet || 0) + (item.tempsAout || 0) + (item.tempsSeptembre || 0) + (item.tempsOctobre || 0) + (item.tempsNovembre || 0) + (item.tempsDecembre || 0)
    const totalTime = item.frequence === 'HEBDOMADAIRE' ? totalTimeHebdomadaire : item.frequence === 'FREQUENTIEL' ? totalTimeFrequentiel : item.frequence === 'A_LA_DEMANDE' ? item.tempsALaDemande : null

    useEffect(() => {
        if (item.chantierId) api.get(`/chantiers/${item.chantierId}`).then(setChantier)
    }, [item.chantierId])

    useEffect(() => {
        if (chantier && !item.id) {
            const hebdomadaireTemps = ["tempsLundi", "tempsMardi", "tempsMercredi", "tempsJeudi", "tempsVendredi", "tempsSamedi", "tempsDimanche"]
            const hebdomadaireKeys = ["heureObligatoireLundi", "heureObligatoireMardi", "heureObligatoireMercredi", "heureObligatoireJeudi", "heureObligatoireVendredi", "heureObligatoireSamedi", "heureObligatoireDimanche", "poubLundiId", "poubMardiId", "poubMercrediId", "poubJeudiId", "poubVendrediId", "poubSamediId", "poubDimancheId", "poubLundi2Id", "poubMardi2Id", "poubMercredi2Id", "poubJeudi2Id", "poubVendredi2Id", "poubSamedi2Id", "poubDimanche2Id"]
            const frequentialTemps = ["tempsJanvier", "tempsFevrier", "tempsMars", "tempsAvril", "tempsMai", "tempsJuin", "tempsJuillet", "tempsAout", "tempsSeptembre", "tempsOctobre", "tempsNovembre", "tempsDecembre"]
            const aLaDemandeTemps = ["tempsALaDemande"]
            if (chantier?.frequence === 'HEBDOMADAIRE') {
                for (let key of hebdomadaireTemps) set(key)(chantier[key])
                for (let key of hebdomadaireKeys) set(key)(chantier[key])
                for (let key of frequentialTemps) set(key)(0)
                for (let key of aLaDemandeTemps) set(key)(0)
            } else if (chantier?.frequence === 'FREQUENTIEL') {
                for (let key of hebdomadaireTemps) set(key)(0)
                for (let key of hebdomadaireKeys) set(key)(null)
                for (let key of frequentialTemps) set(key)(chantier[key])
                for (let key of aLaDemandeTemps) set(key)(0)
            } else if (chantier?.frequence === 'A_LA_DEMANDE') {
                for (let key of hebdomadaireTemps) set(key)(0)
                for (let key of hebdomadaireKeys) set(key)(null)
                for (let key of frequentialTemps) set(key)(0)
                for (let key of aLaDemandeTemps) set(key)(chantier[key])
            }
        }
    }, [chantier])

    useEffect(() => {
        if (personnel && id === 'new') api.get(`/personnel/${relatedId}`).then(item => set('fournisseur1Id')(item.fournisseurId))
    }, [personnel, id, relatedId])

    const onChangePersonnelId = (value, item) => {
        set('personnelId')(value)
        set('fournisseur1Id')(item?.fournisseurId || null)
        set('fournisseur2Id')(null)
        set('fournisseur3Id')(null)
        set('fournisseur4Id')(null)
    }

    return <>
        <Row>
            {personnel
                ? <AsyncSelect className="grow" label={t("Chantier")} value={item.chantierId} onChange={set('chantierId')} onItemLoad={setChantier} options={chantierOptions} required />
                : <AsyncSelect className="grow" label={t("Personnel")} value={item.personnelId} onChange={onChangePersonnelId} options={personnelOptions} required />
            }
            <DateInput label={t("Date de début")} value={item.dateDebut} onChange={set('dateDebut')} required />
            <DateInput label={t("Date de fin")} value={item.dateFin} onChange={set('dateFin')} />
        </Row>
        {item.dateFin && originalItem && !originalItem.dateFin && <div className="text-red-600 font-bold">{t("N'oubliez pas de modifier la déclaration de travaux et le checking !")}</div>}
        <div className="flex flex-col md:grid grid-cols-4 gap-5">
            <AsyncSelect className="grow" label={t("Travaille pour")} value={item.fournisseur1Id} onChange={set('fournisseur1Id')} options={fournisseurOptions} />
            {item.fournisseur1Id && <AsyncSelect className="grow" label={t("Sous-traitant de")} value={item.fournisseur2Id} onChange={set('fournisseur2Id')} options={fournisseurOptions} />}
            {item.fournisseur1Id && item.fournisseur2Id && <AsyncSelect className="grow" label={t("Sous-traitant de")} value={item.fournisseur3Id} onChange={set('fournisseur3Id')} options={fournisseurOptions} />}
            {item.fournisseur1Id && item.fournisseur2Id && item.fournisseur3Id && <AsyncSelect className="grow" label={t("Sous-traitant de")} value={item.fournisseur4Id} onChange={set('fournisseur4Id')} options={fournisseurOptions} />}
            <div className="flex flex-col gap-4">
                <div>{t('Sous-traitant de')}</div>
                <div className="font-bold">{societe?.nom}</div>
            </div>
        </div>
        {chantier && chantier.frequence === 'HEBDOMADAIRE' && <>
            <div className="grid grid-cols-[repeat(8,minmax(100px,1fr))] gap-2 p-1 overflow-auto md:overflow-visible">
                <div></div>
                <div className="flex justify-center items-center">{t('Lundi')}</div>
                <div className="flex justify-center items-center">{t('Mardi')}</div>
                <div className="flex justify-center items-center">{t('Mercredi')}</div>
                <div className="flex justify-center items-center">{t('Jeudi')}</div>
                <div className="flex justify-center items-center">{t('Vendredi')}</div>
                <div className="flex justify-center items-center">{t('Samedi')}</div>
                <div className="flex justify-center items-center">{t('Dimanche')}</div>
                <div className="flex justify-end items-center text-end pr-5">{t('Durée:')}</div>
                <NumberInput className="w-[100px] min-w-full" value={item.tempsLundi} onChange={set('tempsLundi')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsMardi} onChange={set('tempsMardi')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsMercredi} onChange={set('tempsMercredi')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsJeudi} onChange={set('tempsJeudi')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsVendredi} onChange={set('tempsVendredi')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsSamedi} onChange={set('tempsSamedi')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsDimanche} onChange={set('tempsDimanche')} step={0.001} shownDecimals={2} required />
                <div className="flex justify-end items-center text-end pr-5">{t('Heures:')}</div>
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireLundi} onChange={set('heureObligatoireLundi')} />
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireMardi} onChange={set('heureObligatoireMardi')} />
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireMercredi} onChange={set('heureObligatoireMercredi')} />
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireJeudi} onChange={set('heureObligatoireJeudi')} />
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireVendredi} onChange={set('heureObligatoireVendredi')} />
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireSamedi} onChange={set('heureObligatoireSamedi')} />
                <TimeInput className="w-[100px] min-w-full" value={item.heureObligatoireDimanche} onChange={set('heureObligatoireDimanche')} />
                <div className="flex justify-end items-center text-end pr-5">{t('Poubelles:')}</div>
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubLundiId} onChange={set('poubLundiId')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubMardiId} onChange={set('poubMardiId')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubMercrediId} onChange={set('poubMercrediId')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubJeudiId} onChange={set('poubJeudiId')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubVendrediId} onChange={set('poubVendrediId')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubSamediId} onChange={set('poubSamediId')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubDimancheId} onChange={set('poubDimancheId')} options={poubOptions} />
                <div className="flex justify-end items-center text-end pr-5"></div>
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubLundi2Id} onChange={set('poubLundi2Id')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubMardi2Id} onChange={set('poubMardi2Id')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubMercredi2Id} onChange={set('poubMercredi2Id')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubJeudi2Id} onChange={set('poubJeudi2Id')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubVendredi2Id} onChange={set('poubVendredi2Id')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubSamedi2Id} onChange={set('poubSamedi2Id')} options={poubOptions} />
                <AsyncSelect className="w-[100px] min-w-full" value={item.poubDimanche2Id} onChange={set('poubDimanche2Id')} options={poubOptions} />
            </div>
        </>}
        {chantier && chantier.frequence === 'FREQUENTIEL' && <>
            <div className="grid grid-cols-[repeat(7,minmax(100px,1fr))] gap-2 p-1 overflow-auto md:overflow-visible">
                <div></div>
                <div className="flex justify-center items-center">{t('Janvier')}</div>
                <div className="flex justify-center items-center">{t('Février')}</div>
                <div className="flex justify-center items-center">{t('Mars')}</div>
                <div className="flex justify-center items-center">{t('Avril')}</div>
                <div className="flex justify-center items-center">{t('Mai')}</div>
                <div className="flex justify-center items-center">{t('Juin')}</div>
                <div className="flex justify-end items-center text-end pr-5">{t('Durée:')}</div>
                <NumberInput className="w-[100px] min-w-full" value={item.tempsJanvier} onChange={set('tempsJanvier')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsFevrier} onChange={set('tempsFevrier')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsMars} onChange={set('tempsMars')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsAvril} onChange={set('tempsAvril')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsMai} onChange={set('tempsMai')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsJuin} onChange={set('tempsJuin')} step={0.001} shownDecimals={2} required />
            </div>
            <div className="grid grid-cols-[repeat(7,minmax(100px,1fr))] gap-2 p-1 overflow-auto md:overflow-visible">
                <div></div>
                <div className="flex justify-center items-center">{t('Juillet')}</div>
                <div className="flex justify-center items-center">{t('Août')}</div>
                <div className="flex justify-center items-center">{t('Septembre')}</div>
                <div className="flex justify-center items-center">{t('Octobre')}</div>
                <div className="flex justify-center items-center">{t('Novembre')}</div>
                <div className="flex justify-center items-center">{t('Décembre')}</div>
                <div className="flex justify-end items-center text-end pr-5">{t('Durée:')}</div>
                <NumberInput className="w-[100px] min-w-full" value={item.tempsJuillet} onChange={set('tempsJuillet')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsAout} onChange={set('tempsAout')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsSeptembre} onChange={set('tempsSeptembre')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsOctobre} onChange={set('tempsOctobre')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsNovembre} onChange={set('tempsNovembre')} step={0.001} shownDecimals={2} required />
                <NumberInput className="w-[100px] min-w-full" value={item.tempsDecembre} onChange={set('tempsDecembre')} step={0.001} shownDecimals={2} required />
            </div>
        </>}
        {chantier && chantier.frequence === 'A_LA_DEMANDE' && <>
            <Row>
                <NumberInput label={t('Temps à la demande')} value={item.tempsALaDemande} onChange={set('tempsALaDemande')} step={0.001} shownDecimals={2} required />
            </Row>
        </>}
        {totalTime !== null && <div>
            <div className="flex gap-1">
                <div className="font-bold">{t("Temps total:")}</div>
                <div>{t("{temps}h", { temps: totalTime })}</div>
            </div>
            <div className="flex gap-1">
                <div className="font-bold">{t("Prix horaire:")}</div>
                <div>{item.prixVente && totalTime ? toCurrency(item.prixVente / totalTime) : 0}</div>
            </div>
        </div>}
    </>
}

function TempsFieldsPersonnel(props) {
    return <TempsFields {...props} personnel />
}

export function TempsList({ personnel, ...props }) {
    const [chantier, setChantier] = useState()
    const t = useTranslations()
    const api = useApi()
    const { id } = useParams()
    const today = useToday()

    useEffect(() => {
        if (!personnel) api.get(`/chantiers/${id}`).then(setChantier)
    }, [id, personnel])

    return <ListPage model="temps" title={t("Temps")} columns={{
        ...(personnel ?
            { [t('Chantier')]: { sort: 'chantier', value: item => <FkLink>{item.chantier?.nom}</FkLink> } } :
            { [t('Personnel')]: { sort: 'personnel', value: item => <FkLink>{`${item.personnel?.prenom} ${item.personnel?.nom || ''}`}</FkLink> } }
        ),
        [t("Début")]: 'dateDebut',
        [t("Fin")]: 'dateFin',
        ...(personnel || !chantier || chantier?.frequence === "HEBDOMADAIRE" ? {
            [t('Lun')]: { sort: 'tempsLundi', value: item => item.tempsLundi?.toFixed?.(2) },
            [t('Mar')]: { sort: 'tempsMardi', value: item => item.tempsMardi?.toFixed?.(2) },
            [t('Mer')]: { sort: 'tempsMercredi', value: item => item.tempsMercredi?.toFixed?.(2) },
            [t('Jeu')]: { sort: 'tempsJeudi', value: item => item.tempsJeudi?.toFixed?.(2) },
            [t('Ven')]: { sort: 'tempsVendredi', value: item => item.tempsVendredi?.toFixed?.(2) },
            [t('Sam')]: { sort: 'tempsSamedi', value: item => item.tempsSamedi?.toFixed?.(2) },
            [t('Dim')]: { sort: 'tempsDimanche', value: item => item.tempsDimanche?.toFixed?.(2) },
        } : chantier?.frequence === "FREQUENTIEL" ? {
            [t("Jan")]: { value: item => item.tempsJanvier?.toFixed?.(2) },
            [t("Fev")]: { value: item => item.tempsFevrier?.toFixed?.(2) },
            [t("Mch")]: { value: item => item.tempsMars?.toFixed?.(2) },
            [t("Avr")]: { value: item => item.tempsAvril?.toFixed?.(2) },
            [t("Mai")]: { value: item => item.tempsMai?.toFixed?.(2) },
            [t("Jun")]: { value: item => item.tempsJuin?.toFixed?.(2) },
            [t("Jul")]: { value: item => item.tempsJuillet?.toFixed?.(2) },
            [t("Aou")]: { value: item => item.tempsAout?.toFixed?.(2) },
            [t("Sep")]: { value: item => item.tempsSeptembre?.toFixed?.(2) },
            [t("Oct")]: { value: item => item.tempsOctobre?.toFixed?.(2) },
            [t("Nov")]: { value: item => item.tempsNovembre?.toFixed?.(2) },
            [t("Dec")]: { value: item => item.tempsDecembre?.toFixed?.(2) },
        } : {
            [t("Temps à la demande")]: { value: item => item.tempsALaDemande?.toFixed?.(2) },
        })
    }} join={personnel
        ? { chantier: 'nom' }
        : { personnel: 'prenom' }
    } filter={{
        [t('Actifs')]: `dateDebut:lte=${encodeURIComponent(today.toISOString())}&or3:dateFin:gt=${encodeURIComponent(today.toISOString())}&or3:dateFin=`,
        [t('Passés')]: `dateFin:lte=${encodeURIComponent(today.toISOString())}`,
        [t('Futurs')]: `dateDebut:gte=${encodeURIComponent(today.toISOString())}`,
        [t('Tous')]: ``,
    }}  {...props} />
}

export function TempsDetail({ personnel, ...props }) {
    const t = useTranslations()
    const { id } = useParams()

    return <div className="grow">
        {id !== 'new' && <ChantierForm personnel={personnel} />}
        <DetailPage model="temps" title={t("Temps")} Fields={personnel ? TempsFieldsPersonnel : TempsFields} {...props} />
    </div>
}

function ChantierForm({ personnel }) {
    const [originalChantier, setOriginalChantier] = useState()
    const [chantier, setChantier, set] = useObjectState()
    const [temps, setTemps] = useState()
    const api = useApi()
    const { id } = useParams()
    const t = useTranslations()

    const setAllChantiers = chantier => {
        setOriginalChantier({ ...chantier })
        setChantier({ ...chantier })
    }
    useEffect(() => {
        api.get(`/temps/${id}`).then(setTemps)
    }, [id])
    useEffect(() => {
        if (temps?.chantierId) api.get(`/chantiers/${temps?.chantierId}`).then(setAllChantiers)
    }, [temps?.chantierId])

    const onCancel = () => setChantier({ ...originalChantier })
    const onSubmit = () => api.patch(`/chantiers/${temps?.chantierId}`, chantier).then(setAllChantiers)
    const chantierUnchanged = JSON.stringify(originalChantier) === JSON.stringify(chantier)

    if (originalChantier) return <div className="flex justify-center mb-5">
        <div className="md:basis-3/4">
            <h1 className="font-bold text-2xl">{t("Chantier")}</h1>
            <Form onSubmit={onSubmit} className="mt-3 p-5 bg-white border border-gray-300 rounded-xl">
                <div className="flex flex-col gap-5">
                    <ChantierFields item={chantier} set={set} originalItem={originalChantier} tab={t("Heures")} />
                    <Row>
                        <Button gray disabled={chantierUnchanged} icon={<FaBan />} onClick={onCancel}>{t("Annuler")}</Button>
                        <Button submit disabled={chantierUnchanged} icon={<FaSave />}>{t("Sauvegarder et continuer")}</Button>
                    </Row>
                </div>
            </Form>
        </div>
    </div>
}